import { HTMLAttributes, ReactNode } from 'react';
import clsx from 'clsx';

export interface PanelProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  children: ReactNode;
}

export function Panel({ className, children, ...rest }: PanelProps) {
  return (
    <div className={clsx('bg-panel border border-edge rounded-xl shadow-panel', className)} {...rest}>
      {children}
    </div>
  );
}
